import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { DraftContext } from '../../context';

const ProtectedRoute = () => {
  const { user } = useContext(DraftContext);
  return user.roleName && user.roleName !== 'individual' && user.roleName !== 'digital' ? (
    <Outlet />
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectedRoute;
